"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const use_form_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-form-api"));
const Box_1 = __importDefault(require("../../../../../../layouts/Box"));
const Button_1 = __importDefault(require("../../../../../Button"));
const ColumnLayout_1 = __importStar(require("../../../../../../layouts/ColumnLayout"));
const Grid_1 = __importDefault(require("../../../../../../layouts/Grid"));
const Stack_1 = __importDefault(require("../../../../../../layouts/Stack"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const FieldArrayItem = (_a) => {
    var { fields = [], fieldIndex, name, onRemove, removeLabel, showError, isReadOnly, layout, displayLablePerItem, collapse, gridStyle } = _a, props = __rest(_a, ["fields", "fieldIndex", "name", "onRemove", "removeLabel", "showError", "isReadOnly", "layout", "displayLablePerItem", "collapse", "gridStyle"]);
    const formOptions = use_form_api_1.default();
    const getFieldKey = react_1.useCallback((fieldName) => `${name}.${fieldName}`, [name]);
    const editedFields = react_1.useMemo(() => {
        return fields.map((field) => {
            return Object.assign(Object.assign({}, field), { showError, name: getFieldKey(field.name), key: getFieldKey(field.name), stretch: true, label: (collapse || displayLablePerItem) && field.label, description: (collapse || displayLablePerItem) && field.description });
        });
    }, [fields, showError, collapse, getFieldKey, displayLablePerItem]);
    const testId = props['data-testid'];
    const getBox = react_1.useCallback((field) => (react_1.default.createElement(Box_1.default, { width: "100%", pr: 1 }, formOptions.renderForm([
        Object.assign(Object.assign({}, field), { 'data-testid': `${testId}-${field.name}` }),
    ]))), [formOptions, testId]);
    const getHeader = react_1.useCallback((field) => (react_1.default.createElement(Box_1.default, null,
        field.label && react_1.default.createElement(InputLabel_1.default, { htmlFor: getFieldKey(field.name) }, field.label),
        field.description && (react_1.default.createElement(Typography_1.default, { variant: "subtitle1", component: "div" }, field.description)))), [getFieldKey]);
    const renderRow = react_1.useCallback((list, getContent, isHeaderRow = false) => {
        const buttonBoxProps = isHeaderRow
            ? {
                visibility: 'hidden',
                height: '1px',
            }
            : collapse
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    'data-testid': `${testId}-remove-button`,
                }
                : {
                    display: 'flex',
                    alignItems: 'flex-start',
                    pt: 0.3,
                    'data-testid': `${testId}-remove-button`,
                };
        const getKey = (field) => (isHeaderRow ? `${field.name}-header` : field.key);
        return (react_1.default.createElement(Box_1.default, null,
            fieldIndex !== 0 && collapse && react_1.default.createElement(Divider_1.default, { orientation: "horizontal" }),
            react_1.default.createElement(Box_1.default, { display: "flex" },
                react_1.default.createElement(Box_1.default, { flexGrow: 1 }, collapse ? (react_1.default.createElement(Stack_1.default, { spacing: "xs" }, list.map((field) => (react_1.default.createElement(Box_1.default, { key: getKey(field) }, getContent(field)))))) : layout === 'grid' ? (react_1.default.createElement(Grid_1.default, { container: true, className: gridStyle }, list.map((field) => (react_1.default.createElement(Grid_1.default, { item: true, key: getKey(field), xs: field.column }, getContent(field)))))) : (react_1.default.createElement(ColumnLayout_1.default, { renderDivider: false }, list.map((field) => (react_1.default.createElement(ColumnLayout_1.Column, { key: getKey(field) }, getContent(field))))))),
                !isReadOnly && (react_1.default.createElement(Box_1.default, Object.assign({}, buttonBoxProps),
                    react_1.default.createElement(Button_1.default, { onClick: () => {
                            onRemove(fieldIndex);
                        } }, removeLabel))))));
    }, [isReadOnly, removeLabel, onRemove, layout, collapse, fieldIndex, gridStyle, testId]);
    return (react_1.default.createElement("div", { "data-testid": testId },
        fieldIndex === 0 && !collapse && !displayLablePerItem && renderRow(fields, getHeader, true),
        renderRow(editedFields, getBox)));
};
exports.default = FieldArrayItem;
//# sourceMappingURL=index.js.map